"use client";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import $ from "jquery";

const CommonAppScript = () => {
  const pathname = usePathname();
  const [contact_Popup, setcontact_Popup] = useState(false);
  // const [isMainPopup, setIsMainPopup] = useState(false);
  const [isOfferPopup, setSetIsOfferPopup] = useState(false);
  const onOfferPopupClose = () => {
    setSetIsOfferPopup(false);
  };
  const callpopup = () => {
    setcontact_Popup(!contact_Popup);
  };


  useEffect(() => {
    function keypress(event) {
      if (event.keyCode === 27) {
        $("body").removeClass("overflowhidden");
        $(".appendpopup, .testipopup, .storypopup, .popupmainclass").hide();
      }
    }
    document.addEventListener("keydown", keypress);
    return () => {
      document.removeEventListener("keydown", keypress);
    };
  }, []);

  useEffect(() => {
    // Disable right-click
    document.addEventListener("contextmenu", (e) => e.preventDefault());

    function ctrlShiftKey(e, keyCode) {
      return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
    }
    document.onkeydown = (e) => {
      // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
      if (event.keyCode === 123 || ctrlShiftKey(e, "I") || ctrlShiftKey(e, "J") || ctrlShiftKey(e, "C") || (e.ctrlKey && e.keyCode === "U".charCodeAt(0))) return false;
    };

    // (function agent() {
    //   const keyevents = ["keydown", "keypress", "keyup"];
    //   const rejectOtherHandlers = (e) => {
    //     e.stopPropagation();
    //     if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    //     if (e.keyCode == 27) {
    //       var appendPopup = document.querySelector('.appendpopup');
    //       var testiPopup = document.querySelector('.testipopup');
    //       var storyPopup = document.querySelector('.storypopup');
    //       var popupMainClass = document.querySelector('.popupmainclass');
    //       var podcastsplays = document.querySelectorAll('.podcastspause');

    //       if (appendPopup || testiPopup || storyPopup || popupMainClass) {
    //         $("body").removeClass("overflowhidden");
    //         $(".appendpopup, .testipopup, .storypopup").find("iframe").attr("src", "");
    //         $(".appendpopup, .testipopup, .storypopup, .popupmainclass").hide();
    //       }
    //       if (podcastsplays.length > 0) {
    //         podcastsplays.forEach(function (podcast) {
    //           podcast.click();
    //         });
    //       }
    //     }
    //   };

    //   keyevents.forEach((evt) => {
    //     document.addEventListener(evt, rejectOtherHandlers, true);
    //   });

    //   return () => {
    //     keyevents.forEach((evt) => {
    //       document.removeEventListener(evt, rejectOtherHandlers, true);
    //     });
    //   };
    // })();

    document.addEventListener("copy", function (e) {
      e.preventDefault();
      var customMessage = "OOPS! You can't copy the text";
      e.clipboardData.setData("text/plain", customMessage);
    });
  }, []);

  // useEffect(() => {
  //   gtag.pageview(pathname);
  // }, [pathname]);

  // useEffect(() => {
  //   hotjar.initialize(2035961, 6);
  // }, []);
  // // ga4
  // useEffect(() => {
  //   initGA();
  // }, []);
  return <></>;
};

export default CommonAppScript;
